module.exports = "/images/icon-pay-at-close.png?a2e7e25e1ab2284b540a049e0d66b986";